import React, { useEffect, useLayoutEffect, useState } from "react";
import { fetchData, fetchTAMData } from "./fetchData";
import { RA } from "./RA";

import { TAM } from "./TAM";
import "./Auction.css";

import { Auction, TAM as TAMType } from "../../../models/auction";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import { useLocation, useNavigate } from "react-router-dom";
import { DynamicDatePicker } from "../../../components/DatePicker";
import { TabSwitcher } from "../Raj_Dashboard";
import Hamburger from "../../../components/Hamburger";
import { ReactComponent as GNAiIcon } from "../../../icons/gnai_logo.svg";
import { RuvnlTitle } from "../components";
const TABS = ["RA", "TAM"];
export const formatDateString = (date: Date): string =>
  date.toLocaleDateString("en-GB").split("/").reverse().join("-");

export function DemoRajAuctionPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // Read the current 'tab' query parameter from the URL.
  // Default to "analytics" if no tab is specified.
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab") || "dashboard";

  // When a tab is clicked, update the URL accordingly.
  const handleTabChange = (newTab: string) => {
    navigate(`/ruvnl?tab=${newTab}`);
  };
  const [forecastData, setForecastData] = useState<Auction[]>([]);
  const [TAMData, setTAMData] = useState<TAMType[]>([]);
  const [RALoading, setRALoading] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<string>(TABS[0]);
  // const [startDate, setStartDate] = useState(new Date("2024-01-01"));
  // const [endDate, setEndDate] = useState(new Date("2024-02-29"));
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [state, setState] = useState([
    {
      startDate: new Date("2025-01-01"),
      // endDate: new Date() + 2 months to current date,
      endDate: new Date("2025-03-01"),

      key: "selection",
    },
  ]);
  const [dateRange, setDateRange] = useState(state[0]);

  useEffect(() => {
    setRALoading(true);
    fetchData({
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    }).then((data) => {
      setForecastData(data);
      setRALoading(false);
    });
    setLoading(true);
    fetchTAMData({
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    }).then((data) => {
      const aa = data

        .slice()
        .sort(
          (a, b) =>
            new Date(a.date ?? "").getTime() - new Date(b.date ?? "").getTime()
        );

      setTAMData(aa);
      setLoading(false);
    });
  }, [dateRange]);

  useEffect(() => {
    const handleCopyCutPaste = (e: any) => {
      e.preventDefault();
    };

    document.addEventListener("copy", handleCopyCutPaste);
    document.addEventListener("cut", handleCopyCutPaste);
    document.addEventListener("paste", handleCopyCutPaste);

    return () => {
      document.removeEventListener("copy", handleCopyCutPaste);
      document.removeEventListener("cut", handleCopyCutPaste);
      document.removeEventListener("paste", handleCopyCutPaste);
    };
  }, []);

  return (
    <div className="page-wrapper">
      <div className="newheader grid grid-cols-3 gap-3 justify-between items-center">
        <div className="col-span-1">
          <div className="flex items-center gap-5">
            <GNAiIcon width={80} />
            <Hamburger />
            <TabSwitcher />

            <h1 className="text-[18px] text-[#6F6D7C]">TAM and DEEP</h1>
            <div className="selectButton">
              {TABS.map((tab, index) => (
                <div
                  onClick={() => setSelectedTab(tab)}
                  key={tab}
                  style={{
                    borderRadius:
                      index === 0
                        ? "50px 0px 0px 50px"
                        : index === TABS.length - 1
                        ? "0px 50px 50px 0px"
                        : undefined,
                  }}
                  className={
                    selectedTab === tab ? "fiterActive" : "fiterInactive"
                  }
                >
                  {tab}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-span-1">
          <RuvnlTitle />
        </div>

        <div className="col-span-1 flex justify-end">
          {" "}
          <DynamicDatePicker
            defaultDates={dateRange}
            setDate={(date) =>
              setDateRange({
                startDate: date[0].startDate,
                endDate: date[0].endDate,
                key: "selection",
              })
            }
          />
        </div>
      </div>

      <div className="tabContent">
        <div className="gas-page-container">
          <div className=""></div>
          {selectedTab === TABS[0] ? (
            <RA
              forecastData={forecastData}
              startDate={dateRange.startDate}
              endDate={dateRange.endDate}
              loading={RALoading}
            />
          ) : (
            <TAM
              TAMData={TAMData}
              loading={loading}
              startDate={dateRange.startDate}
              endDate={dateRange.endDate}
            />
          )}
        </div>
      </div>
      <div className="gna-footer-container mt-3">
        <div className="grid grid-cols-2 justify-between gap-5 ">
          <p className="gna-footer-text">
            Powered by <strong>GNA Energy</strong>
          </p>
          <strong className="gna-footer-text  text-end">Demo Version</strong>
        </div>
      </div>
    </div>
  );

  // function onDateChange(e: React.ChangeEvent<HTMLInputElement>
  // ){
  //   e.stopPropagation();
  //   setStartDate(new Date(e.target.value))
  // }
}
